import React, { useEffect, useState } from "react";
import { Button, Form, InputNumber, Spin } from "antd";
import { t } from "i18next";
import { getNSSF, updateNSSF } from "services/nssf";
import { Util } from 'common/util';


export default function Index() {
   const [loading, setLoading] = useState(false);
   const [buttonLoading, setButtonLoading] = useState(false);
   const [form] = Form.useForm();

   useEffect(() => {
      setLoading(true);
      getNSSF().then((response) => {
         const data = response.data.data;
         if (data) {
            form.setFieldsValue({
               accident: data.accident,
               health: data.health,
               providentFundStaff: data.providentFundStaff,
               providentFundOrganization: data.providentFundOrganization,
            });
         }
      })
         .finally(() => setLoading(false));
      // eslint-disable-next-line
   }, []);

   const handleOnFocus = (event) => {
      event.target.select();
   }

   const onFinish = (values) => {
      setButtonLoading(true);
      updateNSSF(values).then(() => {
         Util.getInstance().sweetAlertMessage(t("text_success_update"), "success");
      })
         .finally(() => setButtonLoading(false));
   };

   return (
      loading ?
         <Spin
            spinning={loading}
            style={{
               display: "flex",
               justifyContent: "center",
               height: "84vh",
               alignItems: "center",
            }}
         />
         :
         <>
            <div id="title">
               <span>{t("text_nssf")}</span>
            </div>

            <Form form={form} onFinish={onFinish}>
               <Form.Item
                  name="accident"
                  label={t("text_accident")}
                  style={{ width: 275, marginTop: 15, marginLeft: 0 }}
               >
                  <InputNumber
                     placeholder={t("text_accident")}
                     addonAfter="%"
                     onFocus={handleOnFocus}
                  />
               </Form.Item>
               <Form.Item
                  name="health"
                  label={t("text_health")}
                  style={{ width: 275, marginLeft: 0 }}
               >
                  <InputNumber
                     placeholder={t("text_health")}
                     addonAfter="%"
                     onFocus={handleOnFocus}
                  />
               </Form.Item>
               <Form.Item
                  name="providentFundStaff"
                  label={t("text_provident_fund_staff")}
                  style={{ width: 275, marginLeft: 0 }}
               >
                  <InputNumber
                     placeholder={t("text_provident_fund_staff")}
                     addonAfter="%"
                     onFocus={handleOnFocus}
                  />
               </Form.Item>
               <Form.Item
                  name="providentFundOrganization"
                  label={t("text_provident_fund_npa")}
                  style={{ width: 275, marginLeft: 0 }}
               >
                  <InputNumber
                     placeholder={t("text_provident_fund_npa")}
                     addonAfter="%"
                     onFocus={handleOnFocus}
                  />
               </Form.Item>
               <div className="btn-approval">
                  <Button type="primary" htmlType="submit" loading={buttonLoading}>
                     {t("text_save")}
                  </Button>
               </div>
            </Form>
         </>
   );
}
